import { render, staticRenderFns } from "./unfinished.vue?vue&type=template&id=62a924d6&scoped=true&"
import script from "./unfinished.vue?vue&type=script&lang=js&"
export * from "./unfinished.vue?vue&type=script&lang=js&"
import style0 from "./unfinished.vue?vue&type=style&index=0&id=62a924d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a924d6",
  null
  
)

export default component.exports